import { ErrorHandler, Injectable } from '@angular/core';
import { MonitoringService } from './monitoring.service';
@Injectable({ providedIn: 'root' })
export class ErrorHandlerService extends ErrorHandler {
	constructor(private readonly monitoringService: MonitoringService) {
		super();
	}
	handleError(error: Error): void {
		this.monitoringService.logException(error);
	}
}
